var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiwiseUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 842.64 346.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e97a24;fill-rule:evenodd;}.cls-2{font-size:218.44px;fill:#fff;}.cls-2,.cls-3{font-family:CheltenhamItcTEE-Book, CheltenhamItcTEE;}.cls-3{font-size:243.27px;}.cls-3,.cls-4{fill:#231f20;}.cls-4{font-size:54px;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;letter-spacing:0.02em;}.cls-5{letter-spacing:-0.02em;}.cls-6{letter-spacing:0.02em;}.cls-7{letter-spacing:-0.05em;}.cls-8{letter-spacing:0.01em;}.cls-9{letter-spacing:0.02em;}.cls-10{fill:none;stroke:#231f20;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.4,0H276.61A69.6,69.6,0,0,1,346,69.4V276.61a69.6,69.6,0,0,1-69.4,69.4H69.4A69.6,69.6,0,0,1,0,276.61V69.4A69.6,69.6,0,0,1,69.4,0"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(68.68 245.86)"
  }, "D"), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(213.82 245.86)"
  }, "I"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(376.51 237.89)"
  }, "w"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(554.7 237.89)"
  }, "is"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(720.89 237.89)"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(376.04 332.02)"
  }, "DIGI", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 125.06,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 156.76,
    y: 0
  }, "AL"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 231.71,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 261.2,
    y: 0
  }, "Y "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 313.95,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 376,
    y: 0
  }, "ISE")), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 381.67,
    y1: 260.65,
    x2: 841.67,
    y2: 260.65
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiwiseUk);
export default __webpack_public_path__ + "static/media/diwise-uk.eb65a1ea49fdc4881dd56134e85bc8ad.svg";
export { ForwardRef as ReactComponent };